import util from '@/util'
import { mapGetters } from 'vuex'
import { obterIcone } from '@/util/imagem'
import constants from '@/util/constants'
import { mapActions } from 'vuex/dist/vuex.common.js'

export default {
  name: 'itens-carrinho',
  components: {
  },
  props: {
  },

  computed: {
    ...mapGetters('carrinho', ['obterValorTotalCarrinho', 'itensCarrinho']),
    podeAvancar () {
      return !util.valorVazio(this.itensCarrinho)
    }
  },
  data: () => {
    return {
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      }
    }
  },

  methods: {
    ...mapActions('carrinho', ['ActionRemoverItemCarrinho', 'ActionAumentarQuantidadeItemCarrinho', 'ActionDiminuirQuantidadeItemCarrinho']),
    obterIcone (icone) {
      return obterIcone(icone)
    },
    ehProdutoMirt (id) {
      return id === constants.idProdutoMirt
    },
    formatarValorMonetario (valor) {
      if (util.valorEhNulo(valor)) return 'R$ 0'
      return util.formatarValorMonetarioComCifrao(valor)
    },
    diminuirQuantidade ({ item, indice }) {
      this.ActionDiminuirQuantidadeItemCarrinho({ item, indice })
    },
    aumentarQuantidade ({ item, indice }) {
      if (this.ehProdutoMirt(item.produto.id)) return
      this.ActionAumentarQuantidadeItemCarrinho({ item, indice })
    },
    mascaraQuantidade (produto) {
      const ehProdutoMirt = produto.id === constants.idProdutoMirt
      if (ehProdutoMirt) {
        produto.quantidade = 1
        return
      }
      produto.quantidade = util.apenasNumeros(produto.quantidade) ?? 1
    },
    obterTotalComDesconto () {
      const desconto = 0
      const total = this.obterValorTotalCarrinho()
      if (total === 0) return
      return total - desconto
    },
    ehProdutoIlimitado (item) {
      return item.item_planos.ilimitado
    },
    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    }
  }
}
